export const GET_SPECIFICATIONS = "Initialisiere Spezifikationen";
